"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/app/app.module.ts');
const http_1 = require("@angular/common/http");
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const root_component_1 = require("./root.component");
const _4d_mapper_1 = require("4d-mapper");
const material_1 = require("@angular/material");
const http_loader_1 = require("@ngx-translate/http-loader");
const vasat_1 = require("vasat");
const app_service_1 = require("./commons/app.service");
const global_1 = require("./commons/global");
require("rxjs-compat");
const snotify_config_1 = require("./libs/snotify.config");
const environment_1 = require("../environments/environment");
const FourDInjector_1 = require("./commons/FourDInjector");
const identify_interface_1 = require("./xs/interfaces/identify.interface");
const fontawesome_svg_core_1 = require("@fortawesome/fontawesome-svg-core");
const free_brands_svg_icons_1 = require("@fortawesome/free-brands-svg-icons");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
fontawesome_svg_core_1.library.add(pro_solid_svg_icons_1.fas, pro_regular_svg_icons_1.far, pro_light_svg_icons_1.fal, free_brands_svg_icons_1.fab);
const ɵ0 = () => Promise.resolve().then(() => require("./main/map/index.ngfactory")).then((m) => m.MapModuleNgFactory), ɵ1 = () => Promise.resolve().then(() => require("./auth/index.ngfactory")).then((m) => m.AuthModuleNgFactory), ɵ2 = () => Promise.resolve().then(() => require("./main/index.ngfactory")).then((m) => m.MainModuleNgFactory), ɵ3 = () => Promise.resolve().then(() => require("./init/init.module.ngfactory")).then((m) => m.InitModuleNgFactory), ɵ4 = () => Promise.resolve().then(() => require("./v2/index.ngfactory")).then((m) => m.Ver2ModuleNgFactory), ɵ5 = () => Promise.resolve().then(() => require("./v5/index.ngfactory")).then((m) => m.Ver5ModuleNgFactory);
exports.ɵ0 = ɵ0;
exports.ɵ1 = ɵ1;
exports.ɵ2 = ɵ2;
exports.ɵ3 = ɵ3;
exports.ɵ4 = ɵ4;
exports.ɵ5 = ɵ5;
/***********************************************
 *  Main module Routes configuration
 ***********************************************/
exports.routes = [
    { path: '', redirectTo: global_1.AppRoutes.MAIN, pathMatch: 'full' },
    // direct /map/[n] reference, like a direct view-link
    { path: global_1.AppRoutes.MAP, loadChildren: ɵ0 },
    // authentication and user control
    { path: global_1.AppRoutes.AUTH, loadChildren: ɵ1 },
    // main app, normal operation
    { path: global_1.AppRoutes.MAIN, loadChildren: ɵ2 },
    { path: global_1.AppRoutes.INIT, loadChildren: ɵ3 },
    { path: 'v2', loadChildren: ɵ4 },
    { path: 'v5', loadChildren: ɵ5 },
    // {path: 'maker', loadChildren: () => import('./maker/index').then(m => m.MakerModule)},
    { path: '**', component: root_component_1.NotFoundComponent },
];
// window['process'] = {env: {NODE_ENV: environment.production ? 'production' : 'dev'}}
// console.log ( '############', window );
exports.AppRouting = router_1.RouterModule.forRoot(exports.routes);
// console.log ( 'app.module.ts :: routes', AppRouting, routes ) ;
/***********************************************
 *  Translation configuration
 ***********************************************/
function HttpLoaderFactory(http) {
    DEBUG_1.DEBUG.log('/app/app.module.ts', 'HttpLoaderFactory', http);
    return new http_loader_1.TranslateHttpLoader(http);
}
exports.HttpLoaderFactory = HttpLoaderFactory;
/***********************************************
 *  Load vasat instance paramaters from server
 ***********************************************/
function loadVasatInstance(service) {
    DEBUG_1.DEBUG.log('/app/app.module.ts', 'loadVasatInstance', service);
    return () => service.loadInstanceConfig().subscribe();
}
exports.loadVasatInstance = loadVasatInstance;
/*
export function initGapi(gapiSession: GapiSession) {
  return () => gapiSession.initClient();
}*/
var vasat = new vasat_1.Vasat(new vasat_1.VasatConfig(environment_1.environment.production
    ? location.protocol + '//' + location.host + (environment_1.environment.embedded_vasat ? '' : '/vasat')
    : // extra to now have isntance deployed on sandpit to point to live server by default.
        // location.host == 'sandpit.4dmapper.com' ? 'https://beta.4dmapper.com/vasat' :
        // 4dm environments
        //'https://app.4dmapper.com'
        //'https://bmsurvey.mapsender.com/vasat'
        //'https://map.mapsender.com'
        'http://geoshare.geoxpert.com'
// 'https://app.4dlink.com' 
// local development
//    'http://localhost:9000'
// around the world
//'https://cemeteries.ruapehudc.govt.nz/vasat'
//'https://www.4dlink.geolinkjapan.com'
// 'https://4dcan-jp.4dmapper.com/'
// 'https://imagery.outlineglobal.com.au'
, localStorage['last4d_token'] || '4dmapper', localStorage['last4d_secret'] || ''), null);
DEBUG_1.DEBUG.log('/app/app.module.ts', 'Vasat', vasat);
const ɵ6 = snotify_config_1.SnotifyConfig, ɵ7 = new _4d_mapper_1.FourDService(vasat), ɵ8 = vasat, ɵ9 = vasat;
exports.ɵ6 = ɵ6;
exports.ɵ7 = ɵ7;
exports.ɵ8 = ɵ8;
exports.ɵ9 = ɵ9;
class AppModule {
    constructor(matIconRegistry, injector) {
        this.matIconRegistry = matIconRegistry;
        this.__ID = null;
        this.f = null;
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
        matIconRegistry.registerFontClassAlias('fontawesome', 'fa');
        AppModule.injector = injector;
        this.f = new FourDInjector_1.FourDInjector(injector);
        DEBUG_1.DEBUG.log('/app/app.module.ts', 'CONSTRUCTOR', [injector, this.f]);
    }
}
AppModule.injector = null;
exports.AppModule = AppModule;
